// Good reads
// https://github.com/toddmotto/angularjs-styleguide#classes-for-service

// app
import '~/scripts/app';
import '~/scripts/packages';
// style
import '~/styles/main.scss';
import 'prismjs/themes/prism-tomorrow.css';
import 'gridstack/dist/gridstack.min.css';
//
import '../components/home/bookmark/bookmark-block.component';
import '../components/home/dashboard-actions/dashboard-actions-block.component';
import '../components/home/query/query-block.component';
import '../components/home/workflow/workflow-block.component';
import './constants/defaults';
import './controllers/agent-navbar';
import './controllers/fullscreen-loader';
import './controllers/header.controller';
import '../components/home/dashboard-actions/dashboard-actions.controller';
import '../components/home/workflow/workflow-block.controller';
import './controllers/menu-database.controller';
import './controllers/modal/chat-admin';
import './controllers/modal/gis-layer-parameters';
import './controllers/modal/import-excel';
import './controllers/modal/import-excel-action';
import './controllers/modal/kjson';
import '../pages/template-export/modal/template-export-modal';
import '../components/wf/modal/modal-wf-role.controller';
import '../pages/template-export/new/template-export-new.controller';
import './controllers/notification';
import '../pages/preview/preview.controller';
import './directives/disable-drop.directive';
import './directives/dropzone.directive';
import './directives/gis-preview';
import '../components/img-zoom/img-zoom.controller';
import './directives/input-dimensions.directive';
import './directives/ktranslate.directive';
import './directives/modal-movable.directive';
import './directives/modal-resizable.directive';
import './directives/no-dirty-check.directive';
import './directives/node-exec-method.directive';
import './directives/popin-camera.directive';
import '../components/search-bar/pop-info/pop-info.controller';
import './directives/resize.directive';
import './filters/camel-case.filter';
import './filters/human-size.filter';
import './filters/join.filter';
import './filters/listorderby';
import './filters/map';
import './filters/toArray';
import './filters/node-link.filter';
import './filters/obj-length.filter';
import './filters/query/formatcell';
import './filters/query/orderby';
import './filters/query/strpath';
import './filters/shortcut.filter';
import './filters/shuffle';
import './filters/suffix';
import './filters/trusturl';
import './interceptors/nrreplace';
import './providers/isDev';
import './providers/notification';
import './services/reset';
import './services/user';
import './services/agent';
import './services/api';
import './services/cache';
import './services/copy-to-clipboard';
import './services/wrap';
import './services/debounce.factory';
import './services/displayupload';
import './services/e-sign.service';
import './services/evaluator';
import '../pages/template-export/template-export.service';
import './services/form.service';
import './services/frommail';
import './services/help.factory';
import './services/ktranslate';
import './services/mail.service';
import './services/model/action';
import './services/model/address';
import './services/model/attribut';
import './services/model/card';
import './services/model/class-designer';
import './services/model/designer';
import './services/model/droit';
import './services/model/file-download';
import './services/model/file-upload';
import './services/model/form';
import './services/model/lang';
import './services/model/layer';
import './services/model/link';
import './services/model/link-style';
import './services/model/method';
import './services/model/node';
import './services/model/node-definition';
import './services/model/query';
import './services/model/query-variable';
import './services/model/repre';
import './services/model/scenario';
import './services/model/schema';
import './services/model/schema-link';
import './services/model/schema-node';
import './services/model/state';
import './services/model/workflow';
import './services/node.service';
import './services/relations';
import './services/ui-action.service';
import './services/urlutils';
import './services/utils';
import '~/components/bookmark/bookmark.module';
import '~/components/camera/camera.module';
import '~/components/card-grid/card-grid.module';
import '~/components/download/download.module';
import '~/components/form-select/form-select.module';
import '~/components/icon/icon.module';
import '~/components/icon-help/icon-help.module';
import '~/components/img-zoom/img-zoom.module';
import '~/components/input-card/input-card.module';
import '~/components/input-geo/input-geo.module';
import '~/components/json-editor/json-editor.module';
import '~/components/kform/kform.module';
import '~/components/kform-builder/kform-builder.module';
import '~/components/kid/kid.module';
import '~/components/kndef-krepre-list/kndef-krepre-list.module';
import '~/components/kpath/kpath.module';
import '~/components/ktable/ktable.module';
import '~/components/mail/mail.module';
import '~/components/mf/mf.module';
import '~/components/comments/comments.module';
import '~/components/oo-admin/oo-admin.module';
import '~/components/password/password.module';
import '~/components/postal-address/postal-address.module';
import '~/components/qr-code-generator/qr-code-generator.module';
import '~/components/qr-code-scanner/qr-code-scanner.module';
import '~/components/repre/repre.module';
import '~/components/search-bar/search-bar.module';
import '~/components/smart-field/smart-field.module';
import '~/components/ui/ui.module';
import '~/components/wf/wf.module';
import '~/components/zip-arbo/zip-arbo.module';
import '~/components/panel/base-block/base-block.module';
import '~/scripts/directives/resize-observer';
// # Prism
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-bash';
// --- deps

// eslint-disable-next-line no-console,no-undef
console.info(`Starting app in ${process.env.NODE_ENV} mode`);
